import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { Button } from '../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../layouts';
import Welcome from '../../layouts/welcome';
import Row from '../../components/row';
import Container from '../../layouts/containers/container';
import ActivityItemNew from '../../components/activity/activity-item-new';
import List from '../../components/list';
import InputsDropdown from '../../components/inputs/inputs-dropdown';
import SearchBar from '../../components/searchbar';
import ContainerTable from '../../layouts/containers/container-table';
import {nowTimeStamp, stringToDatetimeLocal, stringToFriendlyDatetime} from '../../lib/helpers/datetime-helpers';
import ContainerIndex from '../../layouts/containers/container-index';
import Arrow from '../../components/buttons/arrow';
import MeetingsApi from '../../lib/meetings/meetings-api';
import InputsDate from '../../components/inputs/inputs-date';
import dayjs from 'dayjs';
import EmptyState from '../../components/states/empty';

class BookingsIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bookings: null,
            canceled: {
                label: 'False',
                value: false
            },
            order_direction: {
                label: 'Order by Ascending',
                value: 'asc'
            },
            from: dayjs().startOf('day').toDate(),
            currentPage: 1,
        }
    }

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        MeetingsApi.getMyBookings({
            canceled: this.state.canceled?.value,
            order_direction: this.state?.order_direction?.value,
            from: this.state.from,
            page: this.state.currentPage,
            per_page: 10,
        }).then(({ data, meta }) => {
            this.setState({ bookings: data, meta });
        });
    }

    render() {


        return <ContainerIndex>

            <ContainerIndex.Filters>
                <List gap="20px" style={{ width: '100%' }}>
                    <div>
                        <Container.Text fontSize="18px" color="#FF6933">Booking History</Container.Text>
                    </div>
                    <Row gap="20px" wrap>
                        <InputsDropdown
                            label="Cancelled"
                            value={this.state.canceled}
                            items={[
                                {
                                    label: 'True',
                                    value: true
                                },
                                {
                                    label: 'False',
                                    value: false
                                }
                            ]}
                            onChange={(e) => this.setState({ canceled: e }, () => this.fetch())}
                        />
                        <InputsDropdown
                            label="Order Direction"
                            items={[
                                {
                                    label: 'Order by Ascending',
                                    value: 'asc'
                                },
                                {
                                    label: 'Order by Descending',
                                    value: 'desc'
                                }
                            ]}
                            value={this.state?.order_direction}
                            icon="sort"
                            onChange={(e) => this.setState({ order_direction: e }, () => this.fetch())}
                        />
                        <InputsDate
                            label="From"
                            value={this.state.from}
                            onChange={e => this.setState({ from: e }, () => this.fetch())}
                            dateProps={{
                                placeholderText: 'Select Date'
                            }}
                        />
                    </Row>
                </List>
            </ContainerIndex.Filters>

            <ContainerIndex.Content grid={false}>
                <ContainerTable
                    isEmpty={this.state.bookings?.length === 0 || this.state.bookings === null}
                    ifEmpty={
                        <EmptyState
                            loading={this.state.bookings === null}
                            title="Bookings"
                            description="There does not seem to be any results"
                            titleColor='#FF6933'
                            descriptionColor='black'
                            style={{ minHeight: '300px' }}
                        />
                    }
                    className="table-bookings"
                    columns={[
                        { field: 'Booking Details', width: '50%' },
                        { field: 'Status', width: '12.5%' },
                        { field: 'Value', width: '12.5%' },
                        { field: 'Payment Type', width: '12.5%' },
                        { field: 'View Booking', width: '12.5%' },
                    ]}
                    data={
                        this.state.bookings?.length > 0 ? this.state.bookings?.map((item) => {
                            return [
                                item,
                                item?.canceled === null ? 'Booked' : 'Canceled',
                                `£${item?.saved_quote?.total}`,
                                'Credit BACS',
                                item.id,
                            ]
                        }) : []
                    }
                    rowStyle={{
                        backgroundColor: 'white',
                    }}
                    replaceColumn={{
                        0: (data) => {
                            const name = data?.name !== undefined && data?.name !== null;

                            return (
                                <List gap="10px">
                                    <Container.Text fontSize="16px" color={name ? '#354859' : '#939fa9'}>{ name ? data?.name : 'No Name' }</Container.Text>
                                    <Container.Text fontSize="14px" color="#929BA8">
                                        <Row gap="10px">
                                            <Container.Text color="#FF6933">{ data?.id }</Container.Text> | { stringToFriendlyDatetime(data?.start) }
                                        </Row>
                                    </Container.Text>
                                </List>
                            )
                        },
                        4: (data) => {
                            return (
                                <svg onClick={() => window.location.href = `/mydmc/bookings/${data}`} style={{ cursor: 'pointer', rotate: '-90deg', marginLeft: '40px' }} xmlns="http://www.w3.org/2000/svg" width="17.702" height="18.349" viewBox="0 0 17.702 18.349">
                                    <path id="Path_57" data-name="Path 57" d="M14.211,17.959l6.1-6.151,1.609,1.622-8.851,8.92-8.851-8.92,1.609-1.622,6.1,6.151V4h2.276Z" transform="translate(-4.222 -4)" fill="#cecece"/>
                                </svg>
                            )
                        }
                    }}
                />
            </ContainerIndex.Content>

            <ContainerIndex.Pagination
                currentPage={this.state.currentPage}
                maxPages={this.state.meta?.last_page}
                onNext={() => this.setState({ currentPage: this.state.currentPage + 1 }, () => this.fetch())}
                onPrevious={() => this.setState({ currentPage: this.state.currentPage - 1 }, () => this.fetch())}
            />
        </ContainerIndex>
    }
}

const el = document.getElementById('booking-index');

if (el) {
    ReactDOM.render(
        <Layout
            theme="dark"
            topLeft={<Welcome seam title="Welcome to your" subtitle="Bookings"/>}
            topRight={
                <Row gap="20px">
                    <Button color="orange" rightIcon={<Arrow rotate='-90deg'/>} onClick={() => window.location.href = '/mydmc/meeting-rooms'}>Book</Button>
                </Row>
            }
        >
            <MinMaxLayout
                main={<BookingsIndex/>}
            />
        </Layout>
    , el);
}
